(function () {
  'use strict';

  var overlay = document.querySelector('[data-drawer-overlay]');
  var openDrawer = null;

  function closeDrawers() {
    if (openDrawer) openDrawer.classList.remove('is-open');
    openDrawer = null;
    if (overlay) overlay.classList.remove('is-visible');
    document.body.classList.remove('drawer-open');
  }

  function open(id) {
    var drawer = document.getElementById(id);
    if (!drawer) return;
    closeDrawers();
    drawer.classList.add('is-open');
    openDrawer = drawer;
    if (overlay) overlay.classList.add('is-visible');
    document.body.classList.add('drawer-open');
  }

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-drawer-open]');
    if (opener) {
      e.preventDefault();
      open(opener.getAttribute('data-drawer-open'));
      return;
    }
    if (e.target.closest('[data-drawer-close]') || e.target === overlay) closeDrawers();

    var toggle = e.target.closest('[data-sublist-toggle]');
    if (toggle) {
      var list = document.getElementById(toggle.getAttribute('aria-controls'));
      var expanded = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!expanded));
      if (list) list.classList.toggle('is-open', !expanded);
    }

    var search = e.target.closest('[data-search-toggle]');
    if (search) {
      e.preventDefault();
      var panel = document.querySelector('[data-search-panel]');
      if (panel) {
        panel.classList.toggle('is-open');
        var input = panel.querySelector('input');
        if (input && panel.classList.contains('is-open')) input.focus();
      }
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeDrawers();
  });

  /* Announcement rotation */
  document.querySelectorAll('[data-announcement]').forEach(function (bar) {
    var slides = bar.querySelectorAll('.announcement-slider__slide');
    if (slides.length < 2) return;
    var i = 0;
    var speed = parseInt(bar.getAttribute('data-speed'), 10) || 5000;
    setInterval(function () {
      slides[i].classList.remove('is-active');
      i = (i + 1) % slides.length;
      slides[i].classList.add('is-active');
    }, speed);
  });

  /* Product tabs (For her / For him) */
  document.querySelectorAll('[data-tabs]').forEach(function (wrap) {
    var tabs = wrap.querySelectorAll('[data-tab]');
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var i = tab.getAttribute('data-tab');
        tabs.forEach(function (t) { var on = t === tab; t.classList.toggle('is-active', on); t.setAttribute('aria-selected', on ? 'true' : 'false'); });
        wrap.querySelectorAll('[data-panel]').forEach(function (p) { p.hidden = p.getAttribute('data-panel') !== i; });
      });
    });
  });

  /* Footer columns collapse on phones */
  if (window.matchMedia('(max-width: 768px)').matches) {
    document.querySelectorAll('[data-footer-block]').forEach(function (d) { d.open = false; });
  }

  /* Countdown to the visitor's next midnight, so it restarts every 24 hours */
  function pad(n) { return n < 10 ? '0' + n : String(n); }
  function tick() {
    var end = new Date();
    end.setHours(24, 0, 0, 0);
    var s = Math.max(0, Math.floor((end - Date.now()) / 1000));
    document.querySelectorAll('[data-countdown]').forEach(function (el) {
      var out = el.querySelector('[data-countdown-left]');
      if (out) out.textContent = pad(Math.floor(s / 3600)) + 'h : ' + pad(Math.floor(s % 3600 / 60)) + 'm : ' + pad(s % 60) + 's';
    });
  }
  tick();
  setInterval(tick, 1000);

  /* Testimonials dots */
  document.querySelectorAll('[data-testimonials]').forEach(function (wrap) {
    var track = wrap.querySelector('.testimonials-slider');
    var dots = wrap.querySelectorAll('.testimonials-dots button');
    if (!track || !dots.length) return;
    dots.forEach(function (dot, idx) {
      dot.addEventListener('click', function () {
        var card = track.children[idx];
        if (card) track.scrollTo({ left: card.offsetLeft - track.offsetLeft - (track.clientWidth - card.clientWidth) / 2, behavior: 'smooth' });
      });
    });
    track.addEventListener('scroll', function () {
      var center = track.scrollLeft + track.clientWidth / 2;
      var best = 0;
      var dist = Infinity;
      Array.prototype.forEach.call(track.children, function (c, idx) {
        var d = Math.abs(c.offsetLeft - track.offsetLeft + c.clientWidth / 2 - center);
        if (d < dist) { dist = d; best = idx; }
      });
      dots.forEach(function (d, idx) { d.classList.toggle('is-active', idx === best); });
    }, { passive: true });
  });

  /* Cart */
  function money(cents) {
    var fmt = window.oaMoneyFormat || '${{amount}}';
    var value = (cents / 100).toFixed(2);
    return fmt.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, value.replace(/\B(?=(\d{3})+(?!\d))/g, ','));
  }
  window.oaMoney = money;

  function refreshCart(openAfter) {
    return fetch(window.oaRoutes.root.replace(/\/$/, '') + '/?sections=cart-drawer')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data['cart-drawer'];
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-cart-drawer-content]');
        var current = document.querySelector('[data-cart-drawer-content]');
        if (fresh && current) current.innerHTML = fresh.innerHTML;
        var count = parseInt((fresh && fresh.getAttribute('data-count')) || '0', 10);
        document.querySelectorAll('[data-cart-dot]').forEach(function (d) { d.classList.toggle('is-visible', count > 0); });
        if (openAfter) open('CartDrawer');
      });
  }

  function changeLine(key, qty) {
    return fetch(window.oaRoutes.cartChange, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function () { return refreshCart(false); });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty-change]');
    if (btn) {
      var item = btn.closest('[data-line-key]');
      var input = item.querySelector('input');
      var next = Math.max(0, parseInt(input.value, 10) + parseInt(btn.getAttribute('data-qty-change'), 10));
      input.value = next;
      changeLine(item.getAttribute('data-line-key'), next);
      return;
    }
    var rm = e.target.closest('[data-line-remove]');
    if (rm) {
      e.preventDefault();
      changeLine(rm.closest('[data-line-key]').getAttribute('data-line-key'), 0);
    }
  });

  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-line-key] input');
    if (input) changeLine(input.closest('[data-line-key]').getAttribute('data-line-key'), Math.max(0, parseInt(input.value, 10) || 0));
  });

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-product-form]');
    if (!form) return;
    e.preventDefault();
    var btns = document.querySelectorAll('[data-add-to-cart]');
    var err = form.querySelector('.product-form__error');
    btns.forEach(function (b) { b.disabled = true; });
    fetch(window.oaRoutes.cartAdd, {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: new FormData(form)
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
      .then(function (res) {
        if (!res.ok) {
          if (err) { err.textContent = res.body.description || 'This item could not be added.'; err.classList.add('is-visible'); }
          return;
        }
        if (err) err.classList.remove('is-visible');
        return refreshCart(true);
      })
      .finally(function () { updateButtons(); });
  });

  /* Product page */
  var productRoot = document.querySelector('[data-product]');
  var updateButtons = function () { document.querySelectorAll('[data-add-to-cart]').forEach(function (b) { b.disabled = false; }); };

  if (productRoot) {
    var json = productRoot.querySelector('[data-product-json]');
    var product = json ? JSON.parse(json.textContent) : null;
    var form = productRoot.querySelector('form[data-product-form]');
    var idInput = form && form.querySelector('[name="id"]');
    var sticky = document.querySelector('[data-sticky-atc]');
    var stickySelect = sticky && sticky.querySelector('select');

    var currentVariant = function () {
      if (!product || !idInput) return null;
      var id = parseInt(idInput.value, 10);
      return product.variants.find(function (v) { return v.id === id; }) || null;
    };

    var selectedOptions = function () {
      return Array.prototype.map.call(productRoot.querySelectorAll('[data-option-index]'), function (group) {
        var checked = group.querySelector('input:checked');
        return checked ? checked.value : null;
      });
    };

    var markAvailability = function () {
      var sel = selectedOptions();
      productRoot.querySelectorAll('[data-option-index]').forEach(function (group) {
        var idx = parseInt(group.getAttribute('data-option-index'), 10);
        group.querySelectorAll('input').forEach(function (input) {
          var test = sel.slice();
          test[idx] = input.value;
          var match = product.variants.find(function (v) { return v.options.every(function (o, i) { return o === test[i]; }); });
          input.classList.toggle('is-unavailable', !match || !match.available);
        });
      });
    };

    var render = function (variant) {
      var price = productRoot.querySelector('[data-price]');
      var compare = productRoot.querySelector('[data-compare]');
      var saving = productRoot.querySelector('[data-saving]');
      var label = productRoot.querySelectorAll('[data-option-value]');
      var sel = selectedOptions();
      label.forEach(function (l) { var i = parseInt(l.getAttribute('data-option-value'), 10); if (sel[i]) l.textContent = sel[i]; });
      if (!variant) {
        document.querySelectorAll('[data-add-to-cart]').forEach(function (b) { b.disabled = true; b.textContent = b.getAttribute('data-unavailable'); });
        return;
      }
      idInput.value = variant.id;
      if (price) price.textContent = money(variant.price);
      var onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
      if (compare) { compare.textContent = onSale ? money(variant.compare_at_price) : ''; compare.hidden = !onSale; }
      if (saving) { saving.hidden = !onSale; if (onSale) saving.textContent = Math.round((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price) + '% OFF'; }
      document.querySelectorAll('[data-add-to-cart]').forEach(function (b) {
        b.disabled = !variant.available;
        b.textContent = variant.available ? b.getAttribute('data-available') : b.getAttribute('data-soldout');
      });
      var sp = document.querySelector('[data-sticky-price]');
      if (sp) sp.textContent = money(variant.price);
      if (stickySelect) stickySelect.value = String(variant.id);
      var sv = document.querySelector('[data-sticky-variant]');
      if (sv) sv.textContent = (product.options || []).map(function (n, i) { return n + ': ' + variant.options[i]; }).join(' · ') || variant.title;
      var si = document.querySelector('[data-sticky-img]');
      if (si && variant.featured_media && variant.featured_media.preview_image) {
        var u = new URL(variant.featured_media.preview_image.src, window.location.href);
        u.searchParams.set('width', '120');
        si.src = u.toString();
      }
      if (variant.featured_media) showMedia(variant.featured_media.id);
      if (window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
    };

    productRoot.addEventListener('change', function (e) {
      if (!e.target.closest('[data-option-index]')) return;
      var sel = selectedOptions();
      var variant = product.variants.find(function (v) { return v.options.every(function (o, i) { return o === sel[i]; }); });
      markAvailability();
      render(variant);
    });

    if (stickySelect) {
      stickySelect.addEventListener('change', function () {
        var v = product.variants.find(function (x) { return String(x.id) === stickySelect.value; });
        if (!v) return;
        v.options.forEach(function (val, i) {
          var input = productRoot.querySelector('[data-option-index="' + i + '"] input[value="' + CSS.escape(val) + '"]');
          if (input) input.checked = true;
        });
        markAvailability();
        render(v);
      });
    }

    /* Gallery */
    var slides = productRoot.querySelectorAll('[data-media-id]');
    var thumbs = productRoot.querySelectorAll('[data-thumb]');
    var dots = productRoot.querySelectorAll('.product-gallery__dots span');
    var main = productRoot.querySelector('.product-gallery__main');
    function showMedia(id) {
      var idx = 0;
      slides.forEach(function (s, i) { var on = s.getAttribute('data-media-id') === String(id); if (on) idx = i; s.classList.toggle('is-active', on); });
      thumbs.forEach(function (t) { t.classList.toggle('is-active', t.getAttribute('data-thumb') === String(id)); });
      if (main && window.matchMedia('(max-width: 768px)').matches && slides[idx]) main.scrollTo({ left: slides[idx].offsetLeft, behavior: 'smooth' });
    }
    thumbs.forEach(function (t) { t.addEventListener('click', function () { showMedia(t.getAttribute('data-thumb')); }); });
    if (main) {
      main.addEventListener('scroll', function () {
        var idx = Math.round(main.scrollLeft / main.clientWidth);
        dots.forEach(function (d, i) { d.classList.toggle('is-active', i === idx); });
      }, { passive: true });
    }

    if (product) markAvailability();

    /* Sticky add to cart */
    var mainBtn = form && form.querySelector('[data-add-to-cart]');
    if (sticky && mainBtn && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var e = entries[0];
        sticky.classList.toggle('is-visible', !e.isIntersecting && e.boundingClientRect.top < 0);
      }).observe(mainBtn);
      sticky.querySelector('[data-add-to-cart]').addEventListener('click', function () {
        if (form.requestSubmit) form.requestSubmit(); else form.submit();
      });
    }
  }
})();
